import uuid from "uuid/v4";
import {
  ADD_TO_CART,
  ADJUST_CART_FOR_CHECKOUT,
  DECREMENT_QTY,
  REMOVE_FROM_CART,
  REMOVE_ALL_FROM_CART,
  SAVE_CART,
} from "../actions/cartActions";
import { debounce } from "lodash";

const initState = [];
const saveCart = (cart) => {
  var body =
    "{cart:'" +
    JSON.stringify(cart).replaceAll("'", "\\'") +
    "',IDRef:" +
    localStorage.getItem("IDDetCliRef") +
    "}";
  //console.log(credentials);
  //console.log(body);

  var endpoint = global.endpoint + "/pegaso/updateCart";
  fetch(endpoint, {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    }),
    body: body,
    withCredentials: false,
  })
    .then((res) => res.json())
    .then((result) => { console.log(result); });
};
// Crea una versione "ritardata" del salvataggio
const debouncedSave = debounce((cart) => {
  saveCart(cart);
  // Logica della fetch qui
}, 1000); // Salva solo dopo 1 secondo di inattività

const cartReducer = (state = initState, action) => {
  var cartItems = state,
    product = action.payload;
  //console.log(action.type)

  var _sper = sessionStorage.getItem("personal");
  if (_sper === "undefined") _sper = null;
  const personal = _sper ? JSON.parse(_sper) : {};

  switch (action.type) {
    case SAVE_CART:
      cartItems = product;
      break;
    case ADJUST_CART_FOR_CHECKOUT:
      //console.log(product);
      cartItems = cartItems.map((item) =>
        //item.cartItemId === product.cartItemId ? console.log(product) : console.log(item)
        item.cartItemId === product.cartItemId ? product : item
      );
      //debouncedSave(cartItems);
      break;
    case ADD_TO_CART:
      // for non variant products
      var noSco = false;
      var productNoSco = JSON.parse(sessionStorage.getItem("itemsNoSco") != "undefined"
        ? sessionStorage.getItem("itemsNoSco")
        : "[]");
      if (productNoSco?.find((p) => p.IDArtBas === product.id)) noSco = true;

      if (product.variation === undefined || product.variation.length == 0) {
        var cartItem = cartItems.filter((item) => item.id === product.id)[0];

        if (cartItem === undefined) {
          cartItems = [
            ...cartItems,
            {
              ...product,
              quantity: product.quantity ? product.quantity : 1,
              cartItemId: uuid(),
              sco1:
                personal && personal.TipLis == 4 && !noSco ? personal.S1 : 0,
              sco2:
                personal && personal.TipLis == 4 && !noSco ? personal.S2 : 0,
            },
          ];
        } else {
          cartItems = cartItems.map((item) =>
            item.cartItemId === cartItem.cartItemId
              ? {
                ...item,
                quantity: product.quantity
                  ? parseInt(item.quantity) + parseInt(product.quantity)
                  : parseInt(item.quantity) + 1,
                sco1:
                  personal && personal.TipLis == 4 && !noSco
                    ? personal.S1
                    : 0,
                sco2:
                  personal && personal.TipLis == 4 && !noSco
                    ? personal.S2
                    : 0,
              }
              : item
          );
        }
        // for variant products
      } else {
        const cartItem = cartItems.filter(
          (item) =>
            item.id === product.id &&
            product.selectedProductColor &&
            product.selectedProductColor.split("-")[0] ===
            item.selectedProductColor.split("-")[0] &&
            product.selectedProductSize &&
            product.selectedProductSize === item.selectedProductSize &&
            (product.cartItemId ? product.cartItemId === item.cartItemId : true) &&
            (global.aziendaID === 3
              ? item.IDArtSta === sessionStorage.getItem("IDArtSta")
              : true)
        )[0];
        const variation = product.variation.filter(
          (item) =>
            product.selectedProductColor &&
            product.selectedProductColor === item.color
        )[0];
        if (cartItem === undefined) {
          cartItems = [
            ...cartItems,
            {
              ...product,
              variation: [variation],
              quantity: product.quantity ? product.quantity : 1,
              cartItemId: uuid(),
              sco1:
                personal && personal.TipLis == 4 && !noSco ? personal.S1 : 0,
              sco2:
                personal && personal.TipLis == 4 && !noSco ? personal.S2 : 0,
              IDArtSta: global.aziendaID === 3 ? sessionStorage.getItem("IDArtSta") : null,
              image: [variation?.size.find((s) => s.name === product.selectedProductSize)?.nomImg || variation?.image],
            },
          ];
        } else if (
          cartItem !== undefined &&
          (cartItem.selectedProductColor.split("-")[0] !==
            product.selectedProductColor.split("-")[0] ||
            cartItem.selectedProductSize !== product.selectedProductSize)
        ) {
          cartItems = [
            ...cartItems,
            {
              ...product,
              variation: [variation],
              quantity: product.quantity ? product.quantity : 1,
              cartItemId: uuid(),
              sco1:
                personal && personal.TipLis == 4 && !noSco ? personal.S1 : 0,
              sco2:
                personal && personal.TipLis == 4 && !noSco ? personal.S2 : 0,
              IDArtSta: global.aziendaID === 3 ? sessionStorage.getItem("IDArtSta") : null,
              image: [variation.size.find((s) => s.name === product.selectedProductSize)?.nomImg || variation.image],
            },
          ];
        } else {
          cartItems = cartItems.map((item) =>
            item.cartItemId === cartItem.cartItemId
              ? {
                ...item,
                quantity: product.quantity
                  ? parseInt(item.quantity) + parseInt(product.quantity)
                  : parseInt(item.quantity) + 1,
                variation: [variation],
                selectedProductColor: product.selectedProductColor,
                selectedProductSize: product.selectedProductSize,
                sco1:
                  personal && personal.TipLis == 4 && !noSco
                    ? personal.S1
                    : 0,
                sco2:
                  personal && personal.TipLis == 4 && !noSco
                    ? personal.S2
                    : 0,
                IDArtSta: global.aziendaID === 3 ? sessionStorage.getItem("IDArtSta") : null,
                image: [variation?.size.find((s) => s.name === product.selectedProductSize)?.nomImg || variation?.image],
              }
              : item
          );
        }
      }
      cartItems = cartItems.filter((item) => { return item.quantity > 0 });
      //debouncedSave(cartItems);
      break;
    case DECREMENT_QTY:
      if (product.quantity === 1) {
        const remainingItems = (cartItems, product) =>
          cartItems.filter(
            (cartItem) => cartItem.cartItemId !== product.cartItemId
          );
        cartItems = remainingItems(cartItems, product);
      } else {
        cartItems = cartItems.map((item) =>
          item.cartItemId === product.cartItemId
            ? { ...item, quantity: item.quantity - 1 }
            : item
        );
      }
      //debouncedSave(cartItems);
      break;
    case REMOVE_FROM_CART:
      const remainingItems = (cartItems, product) =>
        cartItems.filter(
          (cartItem) => cartItem.cartItemId !== product.cartItemId
        );
      cartItems = remainingItems(cartItems, product);
      //debouncedSave(cartItems);
      break;
    case REMOVE_ALL_FROM_CART:
      cartItems = cartItems.filter((item) => {
        return false;
      });
      //debouncedSave(cartItems);
      break;
    default:
      cartItems = state;
  }

  return cartItems;
};

export default cartReducer;
